import React from 'react'
import {useRouter} from 'next/router'
import classNames from 'classnames'
import {useTranslation} from '@lib/intl/useTranslations'

import {createLog} from '@util/logs'
import {setUserProperty} from '@util/amplitude'
import {setCookie} from '@util/cookie'
import {editUserLocale} from '@api/user/account/editUserLocale'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'

import Text from '@component/Text/Text'

import CheckIcon from '@svg/common/ic_check.svg'

interface IProps {
    className?: string
}

const LanguageSettingOperation = ({className}: IProps) => {
    const t = useTranslation()
    const router = useRouter()
    const {refetch} = useQueryFetchMe(undefined, false)

    const onChangeLanguage = async (locale: 'en' | 'ko') => {
        createLog('event', 'navigation_change_language', {language: locale})
        setUserProperty('locale', locale)
        setCookie('language', locale)
        await editUserLocale(locale)
        await router.replace(router.asPath, router.asPath, {locale})
        await refetch()
    }
    return (
        <div className={`text-btn_sm transition-colors duration-100 ${className}`}>
            <Text className={'mb-[5px] px-[15px] py-[10px] text-gray01 dark:text-dark_gray01'}>
                {t('globalNavigation.language.menu.title')}
            </Text>
            <div
                onClick={() => onChangeLanguage('en')}
                className={
                    'flex items-center justify-between px-[15px] py-[10px] hover:bg-gray08 dark:hover:bg-dark_gray08 cursor-pointer'
                }>
                <Text
                    className={classNames(
                        'font-normal',
                        router?.locale !== 'ko'
                            ? 'text-primary_shade dark:text-dark_primary_shade'
                            : 'text-gray02 dark:text-dark_gray02',
                    )}>
                    English
                </Text>
                {router?.locale !== 'ko' && (
                    <CheckIcon className={'w-[14px] fill-primary_shade dark:fill-dark_primary_shade'} />
                )}
            </div>
            <div
                onClick={() => onChangeLanguage('ko')}
                className={
                    'flex items-center justify-between px-[15px] py-[10px] hover:bg-gray08 dark:hover:bg-dark_gray08 cursor-pointer'
                }>
                <Text
                    className={classNames(
                        'font-normal',
                        router?.locale === 'ko'
                            ? 'text-primary_shade dark:text-dark_primary_shade'
                            : 'text-gray02 dark:text-dark_gray02',
                    )}>
                    한국어
                </Text>
                {router?.locale === 'ko' && (
                    <CheckIcon className={'w-[14px] fill-primary_shade dark:fill-dark_primary_shade'} />
                )}
            </div>
        </div>
    )
}
export default LanguageSettingOperation
